import * as React from "react";
import type { SVGProps } from "react";
const SvgDocumentWithEuro = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.53 18c-2.29 0-4.27-1.44-5.17-3.5h-.85c-.55 0-1-.45-1-1s.45-1 1-1h.36l-.002-.027c-.009-.16-.018-.312-.018-.473h-.34c-.55 0-1-.45-1-1s.45-1 1-1h.66c.78-2.33 2.89-4 5.37-4 .55 0 1 .45 1 1s-.45 1-1 1c-1.36 0-2.56.81-3.2 2h2.17c.55 0 1 .45 1 1s-.45 1-1 1h-2.66c0 .17 0 .34.03.5h2.64c.55 0 1 .45 1 1s-.45 1-1 1h-1.85c.68.91 1.72 1.5 2.88 1.5.55 0 1 .45 1 1s-.45 1-1 1h-.02Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20 22H4c-.55 0-1-.45-1-1V7a.99.99 0 0 1 .076-.38c.05-.122.123-.234.214-.33l4-4A.99.99 0 0 1 8 2h12c.55 0 1 .45 1 1v18c0 .55-.45 1-1 1ZM9 4h10v16H5V8h3c.55 0 1-.45 1-1V4ZM7 5.41 6.41 6H7v-.59Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDocumentWithEuro;
